import logo from '../assets/reilm-logo.svg'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from './auth/AuthContext'

const Navbar = () => {

  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth()

  const toLanding = () => {
        navigate('/')
    }

  const toPipeline = () => {
        navigate('/pipeline')
    }

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  return (
    <header className="h-[96px] bg-brand-pageFill border-b border-black/5">
      <div className="h-full max-w-canvas mx-auto flex items-center justify-between">
        <div className="flex items-center gap-16 cursor-pointer" onClick={toLanding}>
          <img src={logo} alt="logo" className="w-[160px]" />
        </div>

        <nav className="flex items-center gap-12 text-[18px] font-medium">
          <Link
            to="/pricing"
            className="text-brand-dark hover:text-brand-green transition font-semibold"
          >
            Pricing
          </Link>
        </nav>

        <div className="flex items-center gap-4">
            <>
              <button
                onClick={() => isAuthenticated ? navigate('/pipeline'): navigate('/login')}
                className="h-[40px] text-[14px] px-4 min-w-[84px] rounded-full border border-brand-green text-brand-dark font-semibold"
              >
                Login
              </button>

              <button
                onClick={() => navigate('/signup')}
                className="h-[40px] text-[14px] px-4 rounded-full min-w-[184px] bg-brand-green text-white font-semibold shadow-soft"
              >
                Start 7-Day Free Trial
              </button>
            </>
        </div>
      </div>
    </header>
  )
}

export default Navbar
